// extracted by mini-css-extract-plugin
export default {"container":"S04_container__3Ied9","limiter":"S04_limiter__-27LI","guide":"S04_guide__M4Ydd"};